module.exports = __webpack_public_path__ + "img/Imagen-fondo-g.a3b398ed.svg";